import { createApp } from 'vue';
import HeicToJpgConverter from '@/Components/HeicToJpgConverter.vue';
import '@styles/app.css';

createApp(HeicToJpgConverter).mount('#heic-to-jpg-converter');
